<template>
  <transition
    :css="false"
    @beforeEnter="handleFadeInInit"
    @enter="handleFadeInEnter"
    @leave="handleFadeInLeave"
  >
    <div class="location-image" v-if="menuOpened">
      <transition name="fadeIn">
        <IconTaipei v-if="activeLocation === 0" />
        <IconLA v-if="activeLocation === 1" />
        <IconHK v-if="activeLocation === 2" />
      </transition>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import animations from '@/mixins/animations';

import IconTaipei from '@/components/icons/IconTaipei.vue';
import IconLA from '@/components/icons/IconLA.vue';
import IconHK from '@/components/icons/IconHK.vue';

export default {
  components: {
    IconTaipei,
    IconLA,
    IconHK,
  },
  mixins: [animations],
  computed: {
    ...mapGetters(['activeLocation', 'menuOpened']),
  },
};
</script>

<style lang="scss" scoped>
.location-image {
  position: absolute;
  bottom: 0;
  right: 0;
  @media (min-width: $sm) {
    transform: scale(0.7);
  }
  @media (min-width: $xl) {
    transform: scale(1);
  }
  svg {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.fadeIn-enter-active {
  animation: fadeIn 0.5s;
}

.fadeIn-leave-active {
  animation: fadeIn 0.5s reverse;
}
</style>
